<script lang="ts">
  import Sea from './Sea.svelte';

  import { groundHeightCoefficient } from './pitcyFishConstants';

  export let secondsPerWidth: number;
  export let containerWidth: number;
  export let containerHeight: number;
  export let startMoment: number;

  let groundLeft = 0;
  let midGroundLeft = 0;

  $: groundHeight = containerHeight * groundHeightCoefficient;

  export const updateGroundAndBubblesPosition = () => {
    const groundMsFromReset = (Date.now() - startMoment) % (1000 * secondsPerWidth);
    const groundPercentX = groundMsFromReset / (1000 * secondsPerWidth);

    groundLeft = 0 - containerWidth * groundPercentX;

    const midGroundSlowingCoefficient = 4;
    const midGroundMsFromReset =
      (Date.now() - startMoment) % (midGroundSlowingCoefficient * 1000 * secondsPerWidth);
    const midGroundPercentX =
      midGroundMsFromReset / (midGroundSlowingCoefficient * 1000 * secondsPerWidth);

    midGroundLeft = 0 - containerWidth * midGroundPercentX;

    // console.log(
    //   `
    //   groundPercentX: ${groundPercentX} === ${groundLeft}px
    //   midGroundPercentX: ${midGroundPercentX} === ${midGroundLeft}px
    //   containerWidth: ${containerWidth}
    // `,
    // );
  };
</script>

<Sea left={groundLeft} {containerWidth} {containerHeight} />

<div
  class="ground mid"
  style="
    height: {groundHeight * 1.2}px;
    width: {containerWidth}px;
    background-position-x: {groundLeft}px;
  "
/>
<div
  class="ground"
  style="
    height: {groundHeight}px;
    width: {containerWidth}px;
    background-position-x: {midGroundLeft}px;
  "
/>

<style>
  /** ground container. TODO: Replace bg-color with an image to be animated. */
  .ground {
    position: absolute;
    z-index: 5;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background-image: url('/assets/pitchy-fish/foreground.png');
    background-repeat: repeat-x;
    background-position: left bottom;
    background-position-y: 0px;
    background-size: contain;
  }
  .ground.mid {
    background-image: url('/assets/pitchy-fish/midground.png');
    z-index: 3;
  }
</style>
